import {
    ADD_TO_SHOPING_CART,
    REMOVE_FROM_SHOPING_CART,
    BATCH_REMOVE_FROM_SHOPING_CART,
    SET_SHOPING_CART_ITEM_QUANTITY,
    SET_SHOPING_CART_ITEM_CHECKED,
    CLEAN_SHOPING_CART
} from '../actions/shopingCart';
import lodash from "lodash"

export const initialState = {
    items: [],
    totalQuantity: 0,
};

export const shopingCart = (state = initialState, action) => {
        switch (action.type) {
            case ADD_TO_SHOPING_CART:
                if (state.items.length == 20) {
                    return state;
                }
                var exist = false;
                const newItems = state.items.map(item => {
                    if (item.vasPricing.id == action.vasPricing.id) {
                        exist = true;
                        item.quantity += action.quantity;
                        item.checked = true;
                    }
                    return item;
                })
                if (!exist) {
                    newItems.push({
                        vas: action.vas,
                        vasPricing: action.vasPricing,
                        quantity: action.quantity,
                        checked: true,
                    })
                }
                return {...state, items: newItems, totalQuantity: newItems.reduce((sum, cur) => sum + cur.quantity, 0)};
            case REMOVE_FROM_SHOPING_CART:
                var newItems = state.items
                    .filter(item => item.quantity > 0 && item.vasPricing.id != action.vasPricingId)

                return {...state, items: newItems, totalQuantity: newItems.reduce((sum, cur) => sum + cur.quantity, 0)};
            case BATCH_REMOVE_FROM_SHOPING_CART:
                var newItems = state.items
                    .filter(item => item.quantity > 0 && !lodash.includes(action.vasPricingIds, item.vasPricing.id));

                return {...state, items: newItems, totalQuantity: newItems.reduce((sum, cur) => sum + cur.quantity, 0)};
            case SET_SHOPING_CART_ITEM_QUANTITY:

                var newItems = state.items
                    .map(item => {
                        if (item.vasPricing.id == action.vasPricing.id) {
                            item.quantity = action.quantity;
                        }
                        return item;
                    })
                    .filter(item => item.quantity > 0)
                return {...state, items: newItems, totalQuantity: newItems.reduce((sum, cur) => sum + cur.quantity, 0)};
            case SET_SHOPING_CART_ITEM_CHECKED:

                var newItems = state.items
                    .map(item => {
                        if (item.vasPricing.id == action.vasPricing.id) {
                            item.checked = action.checked;
                        }
                        return item;
                    })
                    .filter(item => item.quantity > 0)
                return {...state, items: newItems};
            case CLEAN_SHOPING_CART:
                return {...state, items: [], totalQuantity: 0};
            default:
                return state;
        }
    }
;



// WEBPACK FOOTER //
// ./src/redux/reducers/shopingCart.js